import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActiveJobProgressComponent } from './components/active-job-progress/active-job-progress.component';
import {FlexLayoutModule} from '@angular/flex-layout';
import {MaterialModule} from '../../core/modules/material/material.module';
import {TimeagoClock, TimeagoFormatter, TimeagoModule} from 'ngx-timeago';
import {ElapsedClock, ElapsedFormatter} from '../../core/modules/common/components/elapsed.formatter';



@NgModule({
  declarations: [ActiveJobProgressComponent],
  exports: [
    ActiveJobProgressComponent
  ],
  imports: [
    CommonModule,
    FlexLayoutModule,
    MaterialModule,
    TimeagoModule.forChild({
      formatter: { provide: TimeagoFormatter, useClass: ElapsedFormatter},
      clock: { provide: TimeagoClock, useClass: ElapsedClock}
    })
  ]
})
export class ActiveJobProgressModule { }
